import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../../Utils/api";
import { 
  adminSubmitUserKycSuccess, 
  adminSubmitUserKycFailure 
} from "../../Action/auth/adminSubmitKycAction";
import { ADMIN_SUBMIT_USER_KYC } from "../../Action/actionTypes";
import { notifySuccess, notifyError } from "../../../Utils/Helper";

function* adminSubmitUserKycRequest(action) {
  console.log('adminSubmitUserKycSaga triggered', action); // Debug log
  try {
    // Extract data safely
    const payload = action.payload || {};
    const { userId, files, callback } = payload;
    console.log('Extracted data:', { userId, files }); // Debug log

    // Create FormData to send files
    const formData = new FormData();
    formData.append('userId', userId);

    // Append files to form data
    Object.keys(files).forEach(key => {
      if (files[key]) {
        formData.append(key, files[key]);
      }
    });

    const response = yield call(api.post, "/admin-submit-user-kyc", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    yield put(adminSubmitUserKycSuccess(response.data));

    // Show success notification
    if (response.data?.meta?.code === 200) {
      notifySuccess(response.data?.meta?.message || 'KYC documents uploaded successfully');
    }

    if (callback && typeof callback === "function") {
      callback(response.data);
    }
  } catch (error) {
    yield put(adminSubmitUserKycFailure());
    
    // Show error notification
    const errorMessage = error.response?.data?.meta?.message || "Failed to upload KYC documents";
    notifyError(errorMessage);
    
    // Safely call callback with error if provided
    const callbackFunc = action?.payload?.callback;
    if (callbackFunc && typeof callbackFunc === "function") {
      callbackFunc(error.response?.data || { meta: { code: 500, message: errorMessage } });
    }
  }
}

export function* watchAdminSubmitUserKycAPI() {
  yield takeEvery(ADMIN_SUBMIT_USER_KYC, adminSubmitUserKycRequest);
}

export default function* rootSaga() {
  yield all([watchAdminSubmitUserKycAPI()]);
}